/*
  KP: dots instead of thumbnails under the main photo, on phones.

  On phones the product photos are already swiped sideways. This hides the strip of small
  photos under them and shows a row of dots over the bottom of the photo instead, one per
  photo, with the current one drawn as a longer dark pill. The dots only show which photo
  is on screen; they are not buttons (swiping is how the photos are changed).

  Only the phone gallery is touched (the theme prints a separate gallery for larger
  screens, which keeps its thumbnails). Products with a single photo get no dots.
  The small photos are hidden, not removed, so the theme's own code that goes with them
  keeps working.

  The theme throws the phone gallery away and draws a new one when the variant changes.
  So the small photos are hidden by a plain style rule that does not depend on this
  script having run, and the script watches the product and puts its dots back (and
  attaches to the new row of photos) whenever the gallery has been re-drawn.

  The look of the dots is in the style rules at the bottom of this file.
  Loaded by snippets/theme-globals.liquid. Delete that line to get the thumbnails back.
*/
(function () {
  function each(list, fn) {
    Array.prototype.forEach.call(list, fn);
  }

  // Run something once, a moment from now: at the next screen redraw, or after a tenth of
  // a second if no redraw comes (a tab in the background does not redraw).
  function later(fn) {
    var done = false;
    var run = function () {
      if (done) return;
      done = true;
      fn();
    };

    window.requestAnimationFrame(run);
    window.setTimeout(run, 100);
  }

  // Make sure one phone gallery has its dots, attached to the row of photos it has NOW,
  // and that the right dot is marked. Safe to call as often as needed.
  function ensure(box) {
    var media = box.querySelector('.product__media');
    var slider = box.querySelector('.scroll-slider__slider');
    if (!media || !slider) return;

    var dots = media.querySelector('.kp-gallery-dots');
    if (!dots) {
      dots = document.createElement('div');
      dots.className = 'kp-gallery-dots';
      dots.setAttribute('aria-hidden', 'true');
      media.appendChild(dots);
    }

    // A new row of photos (the gallery was re-drawn): follow its swiping from now on.
    if (!slider.kpDotsBound) {
      slider.kpDotsBound = true;
      slider.addEventListener('scroll', function () {
        soon(box);
      }, { passive: true });
    }

    // The photos that are really in the row (the theme hides some when a variant has its
    // own set of photos).
    var list = Array.prototype.filter.call(slider.children, function (slide) {
      return slide.offsetWidth > 0;
    });

    if (dots.children.length !== list.length) {
      dots.innerHTML = '';
      list.forEach(function () {
        dots.appendChild(document.createElement('span'));
      });
    }

    var on = list.length > 1;
    if (box.classList.contains('kp-dots-on') !== on) box.classList.toggle('kp-dots-on', on);
    if (!on) return;

    // The photo whose left edge is nearest to where the row has been swiped to.
    var at = slider.scrollLeft + slider.offsetLeft;
    var current = 0;
    var nearest = Infinity;

    list.forEach(function (slide, n) {
      var gap = Math.abs(slide.offsetLeft - at);
      if (gap < nearest) {
        nearest = gap;
        current = n;
      }
    });

    each(dots.children, function (dot, n) {
      var active = n === current;
      if (dot.classList.contains('is-active') !== active) dot.classList.toggle('is-active', active);
    });
  }

  // At most once per screen redraw, however many changes come in.
  function soon(box) {
    if (box.kpDotsWaiting) return;
    box.kpDotsWaiting = true;
    later(function () {
      box.kpDotsWaiting = false;
      ensure(box);
    });
  }

  function ensureAll(root) {
    each((root || document).querySelectorAll('.product__media-container.below-mobile'), ensure);
  }

  function watch(product) {
    if (product.kpDotsWatched) return;
    product.kpDotsWatched = true;

    var waiting = false;
    var again = function () {
      if (waiting) return;
      waiting = true;
      later(function () {
        waiting = false;
        ensureAll(product);
      });
    };

    // Anything re-drawn inside the product (the gallery included), or photos shown/hidden.
    if (window.MutationObserver) {
      new MutationObserver(again).observe(product, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'hidden'] });
    }
  }

  function initAll() {
    each(document.querySelectorAll('.product'), watch);
    ensureAll(document);
  }

  window.addEventListener('resize', function () {
    ensureAll(document);
  });

  var style = document.createElement('style');
  style.textContent = [
    '.product__media-container.below-mobile .product-thumbnails{display:none !important}',
    '.product__media-container.below-mobile .product__media{position:relative}',
    '.kp-gallery-dots{display:none}',
    '.kp-dots-on .kp-gallery-dots{position:absolute;right:0;bottom:12px;left:0;z-index:2;display:flex;align-items:center;justify-content:center;gap:6px;pointer-events:none}',
    '.kp-gallery-dots span{display:block;width:6px;height:6px;border-radius:3px;background:rgba(0,0,0,.22);transition:width .2s ease,background-color .2s ease}',
    '.kp-gallery-dots span.is-active{width:20px;background:#111}'
  ].join('');
  document.head.appendChild(style);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  document.addEventListener('shopify:section:load', initAll);
})();
